import { downloadBlobFromResponse, getCsrfValue } from "~/common/utils/ApiHelper";
import { resolveApiUrl } from "~/utils/url/urlResolver";
import { type QueryType } from "~/features/orders/common/queryTypes";

export enum ReportType {
  CSV = "1",
  XLSX = "0",
}

export interface OrderbookForm {
  filterByOption: QueryType;
  filterByValue: string;
  startDate?: Date;
  endDate?: Date;
  lineStatus?: string;
  deliveryDate?: string;
}

export const downloadOrderbookReport = (data: OrderbookForm, type: ReportType): Promise<any> => {
  const url = resolveApiUrl(`/abmonitor/report/${type}`);

  return fetch(url, {
    body: JSON.stringify(data),
    credentials: "same-origin", // include, omit
    mode: "cors", // no-cors, same-origin
    referrer: "no-referrer", // client
    method: "POST",
    headers: {
      "content-type": "application/json",
      CSRFToken: getCsrfValue(),
    },
  })
    .then(downloadBlobFromResponse)
    .catch((error) => {
      console.warn(error);
    });
};
